"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPictogramLookup = exports.ProductCategories = exports.ProductSubCodes = exports.ProductCodeGroups = exports.ProductCodes = void 0;
//
// Product codes
//
exports.ProductCodes = Object.freeze({
    AEX: 'AEX',
    AFA: 'AFA',
    AFP: 'AFP',
    BCD: 'BCD',
    BTS: 'BTS',
    BUSZERO: 'BUSZERO',
    BWASAVER: 'BWASAVER',
    CBI: 'CBI',
    CCA: 'CCA',
    CCP: 'CCP',
    CDA: 'CDA',
    CFS: 'CFS',
    CIL: 'CIL',
    CSL: 'CSL',
    DCS: 'DCS',
    DDA: 'DDA',
    DIRECTSAVE: 'DIRECTSAVE',
    FCA: 'FCA',
    FEESAVCO: 'FEESAVCO',
    FMS: 'FMS',
    GOLDTD: 'GOLDTD',
    HEROTRAN: 'HEROTRAN',
    HLA: 'HLA',
    HOM: 'HOM',
    LAH: 'LAH',
    LAL: 'LAL',
    LIF: 'LIF',
    MCB: 'MCB',
    MCBCLB: 'MCBCLB',
    MCBCSR: 'MCBCSR',
    MCBCST: 'MCBCST',
    MCCB25: 'MCCB25',
    MCCLOW: 'MCCLOW',
    MCCTXC: 'MCCTXC',
    MCD: 'MCD',
    MCPB25: 'MCPB25',
    MCPLOW: 'MCPLOW',
    MCPQFF: 'MCPQFF',
    MCPTXC: 'MCPTXC',
    MCWQFF: 'MCWQFF',
    MCWTXC: 'MCWTXC',
    MFX: 'MFX',
    MGL: 'MGL',
    MNS: 'MNS',
    MOT: 'MOT',
    MSA: 'MSA',
    OBTD: 'OBTD',
    PBA: 'PBA',
    PBK: 'PBK',
    PLA: 'PLA',
    QFREWARD: 'QFREWARD',
    REWPEN: 'REWPEN',
    RSA: 'RSA',
    SAN: 'SAN',
    SBCS: 'SBCS',
    SIA: 'SIA',
    SMRTESAV: 'SMRTESAV',
    SPA: 'SPA',
    TD: 'TD',
    TDINTRO: 'TDINTRO',
    TRV: 'TRV',
    VCD: 'VCD',
    ZEROTRAN: 'ZEROTRAN',
});
//
// Product code groups
//
exports.ProductCodeGroups = {};
exports.ProductCodeGroups.CREDIT_CARDS = [
    exports.ProductCodes.MCD,
    exports.ProductCodes.VCD,
    exports.ProductCodes.MCB,
    exports.ProductCodes.BCD,
];
exports.ProductCodeGroups.DIRECT_ACCOUNTS = [
    exports.ProductCodes.DDA,
    exports.ProductCodes.CDA,
];
exports.ProductCodeGroups.FINANCIAL_MANAGEMENT_SYSTEM = [
    exports.ProductCodes.FMS,
];
exports.ProductCodeGroups.INSURANCE_HOME_CAR = [
    exports.ProductCodes.HOM,
    exports.ProductCodes.MOT,
    exports.ProductCodes.TRV,
];
exports.ProductCodeGroups.LOAN_PRODUCTS = [
    exports.ProductCodes.PLA,
    exports.ProductCodes.LAH,
    exports.ProductCodes.MSA,
    exports.ProductCodes.MNS,
];
exports.ProductCodeGroups.TRAVEL_MONEY_CARD = [
    exports.ProductCodes.MFX,
];
exports.ProductCodeGroups.COMMSEC_ACCOUNTS = [
    exports.ProductCodes.MGL,
    exports.ProductCodes.CSL,
];
exports.ProductCodeGroups.PRODUCTS_IN_ARREARS = __spreadArrays(exports.ProductCodeGroups.CREDIT_CARDS, [
    exports.ProductCodes.PLA,
    exports.ProductCodes.LAH,
]);
exports.ProductCodeGroups.BUSINESS_PRIVATE_BANKING = [
    exports.ProductCodes.AFA,
    exports.ProductCodes.AFP,
];
exports.ProductCodeGroups.BANKWEST_TRANSACTION = [
    exports.ProductCodes.QFREWARD,
    exports.ProductCodes.ZEROTRAN,
    exports.ProductCodes.HEROTRAN,
    exports.ProductCodes.REWPEN,
    exports.ProductCodes.FEESAVCO,
    exports.ProductCodes.BUSZERO,
];
exports.ProductCodeGroups.BANKWEST_SAVINGS = [
    exports.ProductCodes.DIRECTSAVE,
    exports.ProductCodes.BWASAVER,
    exports.ProductCodes.SMRTESAV,
    exports.ProductCodes.SBCS,
    exports.ProductCodes.BTS,
];
exports.ProductCodeGroups.BANKWEST_DEPOSITS = [
    exports.ProductCodes.TDINTRO,
    exports.ProductCodes.GOLDTD,
    exports.ProductCodes.OBTD,
];
exports.ProductCodeGroups.BANKWEST_CREDIT_CARDS = [
    exports.ProductCodes.MCPLOW,
    exports.ProductCodes.MCCB25,
    exports.ProductCodes.MCPB25,
    exports.ProductCodes.MCCTXC,
    exports.ProductCodes.MCPTXC,
    exports.ProductCodes.MCWTXC,
    exports.ProductCodes.MCBCST,
    exports.ProductCodes.MCBCSR,
    exports.ProductCodes.MCBCLB,
    exports.ProductCodes.MCPQFF,
    exports.ProductCodes.MCWQFF,
    exports.ProductCodes.MCCLOW,
    exports.ProductCodes.MCBCLB,
];
exports.ProductCodeGroups.BANKWEST = __spreadArrays(exports.ProductCodeGroups.BANKWEST_TRANSACTION, exports.ProductCodeGroups.BANKWEST_SAVINGS, exports.ProductCodeGroups.BANKWEST_DEPOSITS, exports.ProductCodeGroups.BANKWEST_CREDIT_CARDS);
//
// Product Sub Codes
//
exports.ProductSubCodes = {
    ESSENTIAL_SUPER_SUBCODE: '33',
    FOREIGN_CURRENCY_SUBCODE: [
        'D3',
        'D4',
    ],
};
//
// Product Categories
//
// Categories derive from Product codes and Product sub codes
exports.ProductCategories = {};
exports.ProductCategories.BUSINESS_ACCOUNTS = [
    exports.ProductCodes.DDA + "07",
    exports.ProductCodes.DDA + "09",
    exports.ProductCodes.DDA + "83",
    exports.ProductCodes.DDA + "B8",
    exports.ProductCodes.DDA + "30",
    exports.ProductCodes.DDA + "78",
    exports.ProductCodes.DDA + "B7",
    exports.ProductCodes.DDA + "13",
    exports.ProductCodes.DDA + "B2",
    exports.ProductCodes.DDA + "B3",
    exports.ProductCodes.DDA + "B4",
    exports.ProductCodes.DDA + "B5",
    exports.ProductCodes.DDA + "B6",
    exports.ProductCodes.DDA + "B7",
    exports.ProductCodes.DDA + "B8",
    exports.ProductCodes.DDA + "B9",
    exports.ProductCodes.DDA + "67",
    exports.ProductCodes.DDA + "C9",
    exports.ProductCodes.MCB + "04",
    exports.ProductCodes.MCD + "34",
    exports.ProductCodes.MCD + "35",
    exports.ProductCodes.MCD + "33",
    exports.ProductCodes.MCD + "14",
    exports.ProductCodes.MCD + "43",
    exports.ProductCodes.MCD + "44",
    exports.ProductCodes.MCD + "45",
    exports.ProductCodes.MCD + "46",
    exports.ProductCodes.MCD + "47",
    exports.ProductCodes.CFS + "57",
    exports.ProductCodes.LAL,
    exports.ProductCodes.DDA,
    exports.ProductCodes.MCB,
];
exports.ProductCategories.ACCOUNTS = [
    exports.ProductCodes.DDA + "04",
    exports.ProductCodes.DDA + "08",
    exports.ProductCodes.DDA + "11",
    exports.ProductCodes.DDA + "16",
    exports.ProductCodes.DDA + "23",
    exports.ProductCodes.DDA + "48",
    exports.ProductCodes.DDA + "54",
    exports.ProductCodes.DDA + "56",
];
exports.ProductCategories.SAVINGS_ACCOUNTS = [
    exports.ProductCodes.DDA + "21",
    exports.ProductCodes.DDA + "34",
    exports.ProductCodes.DDA + "43",
    exports.ProductCodes.DDA + "42",
    exports.ProductCodes.DDA + "47",
    exports.ProductCodes.DDA + "46",
    exports.ProductCodes.DDA + "45",
    exports.ProductCodes.DDA + "58",
    exports.ProductCodes.DDA + "D6",
    exports.ProductCodes.DDA + "86",
    exports.ProductCodes.SIA,
]; // DDA also contains savings account
exports.ProductCategories.INVESTMENT = [
    exports.ProductCodes.CBI + "01",
    exports.ProductCodes.DDA + "05",
    exports.ProductCodes.DDA + "06",
    exports.ProductCodes.DDA + "71",
    exports.ProductCodes.DDA + "33",
    exports.ProductCodes.DDA + "32",
    exports.ProductCodes.DDA + "C5",
    exports.ProductCodes.CSL,
    exports.ProductCodes.MGL,
    exports.ProductCodes.SAN + "22",
    exports.ProductCodes.SAN + "54",
];
exports.ProductCategories.HOME_LOAN_PRODUCTS = [
    exports.ProductCodes.DDA + "C6",
    exports.ProductCodes.DDA + "C7",
    exports.ProductCodes.DDA + "C8",
    exports.ProductCodes.DDA + "96",
    exports.ProductCodes.CFS + "87",
    exports.ProductCodes.LAH,
    exports.ProductCodes.MSA,
]; // DDA also contains two HL accounts
exports.ProductCategories.FOREIGN_CURRENCY = [
    exports.ProductCodes.DDA + "D3",
    exports.ProductCodes.DDA + "D4",
];
exports.ProductCategories.PERSONAL_LOAN = [
    exports.ProductCodes.MNS,
    exports.ProductCodes.PLA,
];
exports.ProductCategories.TERM_DEPOSIT = [
    exports.ProductCodes.CDA,
];
exports.ProductCategories.SUPERANNUATION = [
    exports.ProductCodes.CFS,
    exports.ProductCodes.CCP + "F1",
    exports.ProductCodes.CCP + "D1",
    exports.ProductCodes.CCP + "B1",
    exports.ProductCodes.CCP + "G1",
    exports.ProductCodes.CCP + "H1",
    exports.ProductCodes.CCP + "W1",
    exports.ProductCodes.CCP + "E1",
    exports.ProductCodes.CCP + "C1",
    exports.ProductCodes.CCP + "A1",
    exports.ProductCodes.CCP + "Y1",
    exports.ProductCodes.FMS,
    exports.ProductCodes.RSA,
    exports.ProductCodes.SAN + "62",
    exports.ProductCodes.SAN + "66",
    exports.ProductCodes.SAN + "67",
];
exports.ProductCategories.CARDS = [
    exports.ProductCodes.AEX,
    exports.ProductCodes.MCD,
    exports.ProductCodes.MCD + "4",
    exports.ProductCodes.MCD + "13",
    exports.ProductCodes.MCD + "26",
    exports.ProductCodes.MCD + "31",
    exports.ProductCodes.MCD + "66",
    exports.ProductCodes.MCD + "68",
    exports.ProductCodes.VCD,
];
exports.ProductCategories.INSURANCE = [
    exports.ProductCodes.CIL,
    exports.ProductCodes.CFS + "04",
    exports.ProductCodes.CFS + "13",
    exports.ProductCodes.CFS + "16",
    exports.ProductCodes.CFS + "21",
    exports.ProductCodes.CFS + "38",
    exports.ProductCodes.CFS + "44",
    exports.ProductCodes.CFS + "58",
    exports.ProductCodes.CFS + "71",
    exports.ProductCodes.CFS + "73",
    exports.ProductCodes.CFS + "88",
    exports.ProductCodes.CFS + "90",
    exports.ProductCodes.CFS + "94",
    exports.ProductCodes.CFS + "95",
    exports.ProductCodes.CFS + "96",
    exports.ProductCodes.CFS + "93",
    exports.ProductCodes.CCP + "Q1",
    exports.ProductCodes.CCP + "O1",
    exports.ProductCodes.CCP + "M1",
    exports.ProductCodes.CCP + "K1",
    exports.ProductCodes.CCP + "I1",
    exports.ProductCodes.CCP + "J1",
    exports.ProductCodes.CCP + "X1",
    exports.ProductCodes.CCP + "V1",
    exports.ProductCodes.CCP + "P1",
    exports.ProductCodes.CCP + "N1",
    exports.ProductCodes.CCP + "L1",
    exports.ProductCodes.HOM,
    exports.ProductCodes.LIF,
    exports.ProductCodes.MOT,
    exports.ProductCodes.SAN + "01",
    exports.ProductCodes.SAN + "02",
    exports.ProductCodes.SAN + "14",
    exports.ProductCodes.SAN + "15",
    exports.ProductCodes.SAN + "23",
    exports.ProductCodes.SAN + "24",
    exports.ProductCodes.SAN + "36",
    exports.ProductCodes.SAN + "38",
    exports.ProductCodes.SAN + "59",
    exports.ProductCodes.SAN + "61",
    exports.ProductCodes.SAN + "68",
    exports.ProductCodes.SAN + "69",
    exports.ProductCodes.SAN + "70",
    exports.ProductCodes.SAN + "72",
    exports.ProductCodes.SAN + "73",
    exports.ProductCodes.SAN + "74",
    exports.ProductCodes.SAN + "75",
    exports.ProductCodes.SAN + "76",
    exports.ProductCodes.SAN + "80",
    exports.ProductCodes.TRV,
];
exports.ProductCategories.GENERIC = [
    exports.ProductCodes.AFA,
    exports.ProductCodes.AFP,
    exports.ProductCodes.BCD,
    exports.ProductCodes.DCS,
];
exports.ProductCategories.TRAVEL_MONEY_CARD = [
    exports.ProductCodes.MFX,
];
// Product codes with unknown pictogram assignment
exports.ProductCategories.NOASSIGNEDPICTOGRAM = __spreadArrays([
    'AFH',
    'AFL',
    'CAD',
    'CAS',
    'CBF',
    'CCP',
    'CFD',
    'CFL',
    'CIT',
    'CLS',
    'CMG',
    'CRA',
    'CSN',
    'DER',
    'FAM',
    'LAP',
    'LIM',
    'LMS',
    'LNK',
    'LOC',
    'MAS',
    'MFC',
    'MID',
    'MTX',
    'OFS',
    'PBA',
    'PRR',
    'PRT',
    'SAN',
    'SDC',
    'SPA',
    'STA',
    'TRD',
    'WSS'
], exports.ProductCodeGroups.BANKWEST);
// Product codes that have not been used
// export const UNSUPPORTED_FOREIGN_CURRENCY = ['D5']; // vostro, nostro accounts
// export const INSURANCE_LIFE = ['CIL', 'LIF', 'CCP'];
exports.ProductPictogramLookup = {};
exports.ProductCategories.BUSINESS_ACCOUNTS.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Business48';
});
exports.ProductCategories.ACCOUNTS.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Accounts48';
});
exports.ProductCategories.SAVINGS_ACCOUNTS.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Saving48';
});
exports.ProductCategories.INVESTMENT.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Shares48';
});
exports.ProductCategories.HOME_LOAN_PRODUCTS.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'HomeBuying48';
});
exports.ProductCategories.FOREIGN_CURRENCY.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'ForeignCurrency48';
});
exports.ProductCategories.PERSONAL_LOAN.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'StandardVehicle48';
});
exports.ProductCategories.TERM_DEPOSIT.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'TermDeposit48';
});
exports.ProductCategories.TRAVEL_MONEY_CARD.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Travel48';
});
exports.ProductCategories.SUPERANNUATION.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Superannuation48';
});
exports.ProductCategories.CARDS.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Cards48';
});
exports.ProductCategories.INSURANCE.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Insurance48';
});
exports.ProductCategories.GENERIC.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Accounts48';
});
exports.ProductCategories.NOASSIGNEDPICTOGRAM.forEach(function (product) {
    exports.ProductPictogramLookup[product] = 'Accounts48';
});
